/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-24 12:08:22
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/versionContent.ts
 */
import {
  SalesChannelContent,
  SalesChannelContentListPageSalesChannelContentListPage,
  ContentPublishRequest,
  SalesChannelContentPublishPage,
  DefaultVersion,
} from './types';
import { get, post, remove } from 'src/tools/server';

const getSalesChannelContents = (salesChannelUuid) => {
  return get<SalesChannelContentPublishPage>(
    `/portal/salesChannelContentListPage/${salesChannelUuid}`,
    {},
  );
};

const deleteSalesChannelVersion = (salesChannelUuid) => {
  return remove<SalesChannelContent>(
    `/portal/salesChannelContent/${salesChannelUuid}`,
    {},
  );
};

const createVersion = (
  body: SalesChannelContent,
): Promise<SalesChannelContent> => {
  return post<SalesChannelContent>(`/portal/salesChannelContent`, body, {});
};

const versionRename = (body): Promise<SalesChannelContent> => {
  return post<SalesChannelContent>(
    `/portal/salesChannelContent/rename`,
    body,
    {},
  );
};

const duplicateVersion = (body): Promise<SalesChannelContent> => {
  return post<SalesChannelContent>(
    `/portal/salesChannelContent/duplicate`,
    body,
    {},
  );
};

const initializePublish = (
  salesChannelContentUuid,
): Promise<SalesChannelContentListPageSalesChannelContentListPage> => {
  return get<SalesChannelContentListPageSalesChannelContentListPage>(
    `/portal/salesChannelContentPublishPage/${salesChannelContentUuid}`,
    {},
  );
};

const publishVersion = (
  data: ContentPublishRequest,
): Promise<SalesChannelContent> => {
  return post<SalesChannelContent>(
    `/portal/salesChannelContent/publish`,
    data,
    {},
  );
};
const unPublishVersion = (
  salesChannelContentUuid: string,
): Promise<SalesChannelContent> => {
  return post<SalesChannelContent>(
    `/portal/salesChannelContent/unpublish/${salesChannelContentUuid}`,
    {},
    {},
  );
};

const defaultVersion = (
  salesChannelContentUuid: string,
): Promise<DefaultVersion> => {
  return get(
    `/portal/salesChannelContent/defaultVersion/${salesChannelContentUuid}`,
    {},
  );
};

export {
  getSalesChannelContents,
  deleteSalesChannelVersion,
  createVersion,
  versionRename,
  duplicateVersion,
  initializePublish,
  publishVersion,
  unPublishVersion,
  defaultVersion,
};
